import React, { Component } from 'react'
import TitleBar from '../TitleBar'
import SessionFilterRow from './SessionFilterRow.js'
import getLabel from '../../utilities/label.js'
import _ from 'lodash'
import './index.css'

export default class SessionFilterScreen extends Component {
  constructor(props){
    super(props)
    this.state = {
      trackNames: this.getCategoryList('track_name'),
      typeNames: this.getCategoryList('session_type'),
      roomNames: this.getCategoryList('room_name')
    }
  }

  getCategoryList(fieldName) {
    const { sessions } = this.props
    return _.uniq(_.compact(_.map(sessions, (session) => {
      return session[fieldName]
    })))
  }
    

  toggle(key, secondKey) {
    return () => this.props.toggleFilter(key, secondKey)
  }

  renderSubheader(labelKey) {
    return (
      <div className="filter-subheader">
        { getLabel({ key: labelKey, plural: true}) }
      </div>
    )
  }

  renderTrackSection() {
    return (
      <div>
        { this.renderSubheader('track') }
        { this.renderTrackFilters() }
      </div>
    )
  }

  renderTrackFilters() {
    const { agendaFilters } = this.props
    const { trackNames } = this.state
    return _.map(trackNames, (trackName) => {
      return (
        <SessionFilterRow
          key={ trackName }
          label={ trackName }
          isChecked={ agendaFilters.tracks[trackName] }
          onChange={ this.toggle('tracks', trackName) } />
      )
    })
  }

  renderTypeSection() {
    return (
      <div>
        { this.renderSubheader('session_type') }
        { this.renderTypeFilters() }
      </div>
    )
  }

  renderTypeFilters() {
    const { agendaFilters } = this.props
    const { typeNames } = this.state
    return _.map(typeNames, (typeName) => {
      return (
        <SessionFilterRow
          key={ typeName }
          label={ typeName }
          isChecked={ agendaFilters.types[typeName] }
          onChange={ this.toggle('types', typeName) } />
      )
    })
  }

  renderRoomSection() {
    return (
      <div>
        { this.renderSubheader('room') }
        { this.renderRoomFilters() }
      </div>
    )
  }

  renderRoomFilters() {
    const { agendaFilters } = this.props
    const { roomNames } = this.state
    return _.map(roomNames, (roomName) => {
      return (
        <SessionFilterRow
          key={ roomName }
          label={ roomName }
          isChecked={ agendaFilters.rooms[roomName] }
          onChange={ this.toggle('rooms', roomName) } />
      )
    })
  }

  render() {
    const { agendaFilters } = this.props
    const {
      trackNames,
      typeNames,
      roomNames } = this.state
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    return (
      <div>
        <TitleBar
          title={ getLabel('filter') }
          leftButtonLabel={ backButton }
          leftButtonAction={ this.props.toggleFilterScreen }
          rightButtonLabel={ getLabel('reset_filter') }
          rightButtonAction={ this.props.resetFilters } />
        <SessionFilterRow
          label={ getLabel('my_schedule') }
          isChecked={ agendaFilters['mySchedule'] }
          onChange={ this.toggle('mySchedule') } />
        <SessionFilterRow
          label={ getLabel('registration_required') }
          isChecked={ agendaFilters['registrationRequired'] }
          onChange={ this.toggle('registrationRequired') } />
        { trackNames.length > 0 && this.renderTrackSection() }
        { typeNames.length > 0 && this.renderTypeSection() }
        { roomNames.length > 0 && this.renderRoomSection() }
      </div>
    )
  }
}
